// source: pbtypes/gen/phone/button_action.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.phone.ButtonAction', null, global);
goog.exportSymbol('proto.phone.ButtonAction.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.phone.ButtonAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.phone.ButtonAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.phone.ButtonAction.displayName = 'proto.phone.ButtonAction';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.phone.ButtonAction.prototype.toObject = function(opt_includeInstance) {
  return proto.phone.ButtonAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.phone.ButtonAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.ButtonAction.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.phone.ButtonAction}
 */
proto.phone.ButtonAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.phone.ButtonAction;
  return proto.phone.ButtonAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.phone.ButtonAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.phone.ButtonAction}
 */
proto.phone.ButtonAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.phone.ButtonAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.phone.ButtonAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.phone.ButtonAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.ButtonAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.phone.ButtonAction.Enum = {
  UNDEFINED: 0,
  MAP_TOGGLE: 1,
  VIDEO_STREAM_TOGGLE: 2,
  OBSTACLE_AVOIDANCE_CLOSE: 3,
  OBSTACLE_AVOIDANCE_MINIMAL: 4,
  OBSTACLE_AVOIDANCE_DISABLED: 5,
  OBSTACLE_AVOIDANCE_STANDARD: 32,
  ZOOM: 6,
  EV_ADJUST: 7,
  GIMBAL: 8,
  STOP_AT_STRUCTURE: 9,
  OBSTACLE_AVOIDANCE_TOGGLE: 10,
  STROBE_TOGGLE: 11,
  RETURN_TO_HOME: 12,
  CYCLE_DISPLAY_LAYOUT: 13,
  CYCLE_FULL_SCREEN_VIEW: 14,
  CYCLE_COLOR_PALETTE: 15,
  RESET_GIMBAL_ZOOM: 16,
  RGB_TOGGLE: 17,
  EV_INCREASE: 18,
  EV_DECREASE: 19,
  GPS_FLIGHT_TOGGLE: 20,
  NIGHTSENSE_TOGGLE: 21,
  ATTITUDE_MODE_HOLD: 22,
  ANNOTATE_LINK_QUALITY: 23,
  SPEAKER_MIC_HOLD_TO_TALK: 24,
  FORCE_VIO_DEGRADED: 25,
  ATTITUDE_MODE_TOGGLE: 26,
  SCREENSHOT: 27,
  QUICK_ACTION_YAW: 28,
  QUICK_ACTION_GIMBAL: 29,
  HEADING_STEP_LEFT: 30,
  HEADING_STEP_RIGHT: 31,
  SELECT_CLOSEST_ASSET: 33,
  TAK_ADD_MARKER_AT_CROSSHAIR: 34,
  GEO_LOOKAT_CURRENT_CROSSHAIR: 35
};

goog.object.extend(exports, proto.phone);
